import { createSelector } from '@ngrx/store';
import { SelectSupplierModuleState } from '../suppliermodule.selector';

export const getProductState = createSelector(SelectSupplierModuleState, state => state.ProductState);
export const getCommodities = createSelector(getProductState, state => state.commodities);
